import { type GetHookResponse } from '../hooks'
import { videoReportsKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type VideoReportsInput, type VideoData, type VideoReportsSuccess } from '@terros/common'

export function useVideoReports(limit?: number): GetHookResponse<VideoData[]> {
  return useTantalimQuery<VideoReportsInput, VideoReportsSuccess, VideoData[]>({
    convertResponse: (data) => {
      return data.videos
    },
    input: { limit },
    queryKey: videoReportsKey(limit),
    url: '/video/reports',
  })
}
